export default "__VITE_ASSET__Bk$0VDps__"